import { render, staticRenderFns } from "./GroupMembers.vue?vue&type=template&id=34b36786&scoped=true"
import script from "./GroupMembers.vue?vue&type=script&lang=js"
export * from "./GroupMembers.vue?vue&type=script&lang=js"
import style0 from "./GroupMembers.vue?vue&type=style&index=0&id=34b36786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b36786",
  null
  
)

export default component.exports